import { observer } from "mobx-react-lite";
import { useEffect } from "react";
import type { FormValuesToSubmit } from "../../../common/types/formTypes";
import { isErrorOccured, isWaitingForData } from "../../../common/utils/asyncDataUtils";
import authStore from "../../../stores/auth/authStore";
import uiStore, { LOGIN_MODE } from "../../../stores/uiStore";
import Button from "../../Button";
import ErrorAlertWithOptionalTracking from "../../ErrorAlertWithOptionalTracking";
import { validateOtpCode } from "../../formvalidation/FormUtils/FieldValidators";
import ValidatedForm from "../../formvalidation/ValidatedForm";
import ValidatedInput from "../../formvalidation/ValidatedInput";
import PasswordField from "../../password-field/PasswordField";

const InputOtp = () => {
   const resetSuccess = authStore.resetPasswordProgress.data;

   useEffect(() => {
      if (resetSuccess) {
         uiStore.switchLoginMode(LOGIN_MODE.RESET_PASSWORD_SUCCESS);
      }
   }, [resetSuccess]);

   const handleSubmit = async (submittedFormValues: FormValuesToSubmit) => {
      await authStore.attemptResetPassword(submittedFormValues.otp as string, submittedFormValues.password as string);
      return isErrorOccured(authStore.resetPasswordProgress) ? { resetFormFields: false } : { resetFormFields: true };
   };

   return (
      <>
         <p>Du har fått tilsendt engangskode over e-post. Fyll inn koden og oppgi nytt passord.</p>
         <ValidatedForm onSubmit={handleSubmit} className="flex flex-col gap-2">
            <ValidatedInput name="otp" label="Engangskode (6 tegn)" initialValue="" validator={validateOtpCode} required />
            <PasswordField name="password" />
            {isErrorOccured(authStore.resetPasswordProgress) && (
               <ErrorAlertWithOptionalTracking
                  showCloseButton={false}
                  gaErrorTracking={{ context: "login", text: "reset_password_error" }}
               >
                  Noe gikk galt ved endring av passord. Prøv igjen senere.
               </ErrorAlertWithOptionalTracking>
            )}
            <Button
               type="submit"
               size="full"
               disabled={isWaitingForData(authStore.resetPasswordProgress)}
               trackingName="Bekreft nytt passord innloggingsmodal"
            >
               Sett nytt passord
            </Button>
         </ValidatedForm>
      </>
   );
};

export default observer(InputOtp);
